import Vue from 'vue'
import Router from 'vue-router'
import Questions from '@/components/pages/questions/Questions'
import Insurances from '@/components/pages/insurances/Insurances'
import ContactInfo from '@/components/pages/contactInfo/ContactInfo'
import InsuranceContact from '@/components/pages/insuranceContact/InsuranceContact'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'QuestionsDefault',
      component: Questions
    },
    {
      path: '/:cvr/Questions/:step',
      name: 'Questions',
      component: Questions,
      props: true
    },
    {
      path: '/:cvr/Insurances',
      name: 'Insurances',
      component: Insurances
    },
    {
      path: '/ContactInfo',
      name: 'ContactInfo',
      component: ContactInfo
    },
    {
      path: '/InsuranceContact',
      name: 'InsuranceContact',
      component: InsuranceContact
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js